import useMessageDetailsGeneric, {
    MessageDetailsGenericResponse,
    MessageTrigger,
    type MessageAttachment,
    type Trigger,
} from './useMessageDetailsGeneric';

// Export re-usable types and constants
export { MessageTrigger };
export type { MessageAttachment, Trigger };

// Inbox-specific response type (alias to generic)
export interface MessageDetailsInboxResponse extends MessageDetailsGenericResponse {}

/**
 * Hook for fetching inbox message details
 * This is a wrapper around useMessageDetailsGeneric for backward compatibility
 */
const useMessageDetailsInboxApi = (messageId: string) => {
  return useMessageDetailsGeneric({ messageId, endpointType: 'inbox' });
};

export default useMessageDetailsInboxApi;